import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { HelpCircle } from "lucide-react";
import { faqs, OFFER_ANCHOR, CTA_TEXT } from "../../data/mock";
import { Button } from "../ui/button";

const FAQ = () => {
  return (
    <section className="section-pad bg-white">
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-[11px] md:text-xs font-bold tracking-widest text-pink-600 uppercase">
            <HelpCircle className="w-4 h-4" /> Dúvidas frequentes
          </span>
          <h2 className="mt-2 font-serif-display font-black text-2xl md:text-5xl text-pink-700 leading-tight">
            Perguntas Frequentes
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-6 md:mt-8 space-y-2.5 md:space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-pink-50/70 border border-pink-100 rounded-xl px-4 md:px-5 data-[state=open]:bg-pink-50"
            >
              <AccordionTrigger className="text-left font-semibold text-pink-800 hover:no-underline hover:text-pink-700 text-[14px] md:text-base py-4">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-pink-900/80 leading-relaxed text-[13px] md:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-6 md:mt-10 text-center">
          <a href={OFFER_ANCHOR}>
            <Button size="lg" className="w-full sm:w-auto bg-gradient-to-b from-pink-500 to-rose-600 hover:from-pink-600 hover:to-rose-700 text-white font-bold px-6 md:px-8 py-5 rounded-full shadow-lg text-sm md:text-base">
              👉 {CTA_TEXT}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
